/**
 * Massstab einer Viewer-Buehne, die per CSS `transform: scale()` verkleinert
 * angezeigt wird (Jans Fund 23.09.2026: „die Mini-Vorschau zuckt regelmaessig
 * zwei Mal, ein Slide wird doppelt angezeigt").
 *
 * Die Galerie-Hover-Vorschau rendert eine virtuelle 420x560-Buehne und
 * schrumpft sie per `transform: scale(...)` in die Kachel. `scrollTop` zaehlt
 * dabei in LAYOUT-Pixeln (560 hoch), `getBoundingClientRect()` liefert aber
 * BILDSCHIRM-Pixel (280 hoch). Die Slide-Positionen mischen beides:
 * Rechteck vom Bildschirm + `scrollTop` aus dem Layout. Solange bei
 * Scroll-Position 0 gemessen wird, faellt das nicht auf — vermisst ein
 * ResizeObserver MITTEN in der Fahrt neu, wandern alle Positionen um
 * `scrollTop x (1 - Massstab)`. Der aktuelle Slide kippt dann fuer ein paar
 * Bilder auf den vorigen zurueck: der Slide erscheint ein zweites Mal.
 *
 * Mit dem Massstab wird der Scroll-Weg in dieselbe Einheit gebracht wie die
 * gemessenen Rechtecke — die Neuvermessung liefert dann unabhaengig von der
 * Scroll-Position dieselben Positionen.
 */

/** Sicht-Hoehe / Layout-Hoehe der Buehne; 1 = unskaliert (Normalfall). */
export function positionsSkala(sichtHoehe: number, layoutHoehe: number): number {
    if (!Number.isFinite(sichtHoehe) || !Number.isFinite(layoutHoehe)) return 1;
    if (sichtHoehe <= 0 || layoutHoehe <= 0) return 1;
    const s = sichtHoehe / layoutHoehe;
    // Nur echte Verkleinerungen/Vergroesserungen beachten; Rundung (0,5 px auf
    // 560) darf die Positionen nicht verschieben.
    if (Math.abs(s - 1) < 0.01) return 1;
    // Unsinnige Werte (Element gerade ausgeblendet o. ae.) nicht anwenden.
    if (s < 0.05 || s > 20) return 1;
    return s;
}
